export const STARRED_TEST_ID = 'gsn-starred';
